@if (banner) {
<section class="ptb">
  <div class="ptb-decor" aria-hidden="true">
    <span class="ptb-circle ptb-circle-lg"></span>
    <span class="ptb-circle ptb-circle-md"></span>
    <span class="ptb-circle ptb-circle-sm"></span>
  </div>

  <div class="ptb-card">
    <div class="ptb-body">
      <img class="ptb-brand" src="assets/images/jm-logo-tpb.png" alt="JustMoney">

      <div class="ptb-content">
        @if (pageName =='account') {
        <p class="ptb-notification">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 20V13M9 20V7M15 20V14M21 20V4" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" />
          </svg>
          @if(banner.priority==1){
          Your report: R{{creditReportBalance | number:'1.0-0' }} across {{totalOpenAccount }} open accounts
          }
          @if(banner.priority==2){
          Your credit score: {{myCreditScore}}
          }
          @if (banner.priority==3) {
          Your credit score: {{myCreditScore}}
          }

        </p>
        }

        <h2 class="ptb-heading">{{ banner.heading }}</h2>
        <p class="ptb-subheading">{{ banner.subheading }}</p>

        <button #ctaButton type="button" class="ptb-cta mb-lg-3 mb-0" id="{{ banner.ctaId }}_{{ pageName }}"
          (click)="handleBannerCta(banner.priority, ctaButton.id)">{{ banner.ctaText
          }}</button>
      </div>
    </div>

    <div class="ptb-partner">
      @if (banner.logoImg) {
      <span>In partnership with</span>
      <img [src]="banner.logoImg" class="partner-logo" alt="Partner logo">
      } @else {
      <span class="ptb-tagline">{{ banner.tagline }}</span>
      }
    </div>
  </div>
</section>


<ng-template #callbackErrorModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="callbackErrorModelClosed"
      name="callbackErrorModelClosed" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span id="callbackErrorModelClosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-danger" role="alert">
    <p>{{callBackErrorDebt}}</p>
  </div>
</ng-template>


<ng-template #lesDeclineModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title"></h4>
    <button type="button" class="close" id="lesDeclineModal_Declined_PopUpclosed" data-dismiss="modal"
      name="lesDeclineModal_Declined_PopUpclosed" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span id="lesDeclineModal_Declined_PopUpclosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Your application with Sanlam Personal Loans is still in progress. You should receive feedback shortly. Please
      feel free tot chat to your coach if you have any questions?</p>
  </div>
</ng-template>

}